export const HEADER_BANNER_DATA_TEST_ID = 'HEADER_BANNER_DATA_TEST_ID';
export const HEADER_BANNER_DESKTOP_DATA_TEST_ID =
  'HEADER_BANNER_DESKTOP_DATA_TEST_ID';
export const HEADER_BANNER_LINK_DATA_TEST_ID =
  'HEADER_BANNER_LINK_DATA_TEST_ID';
